import { render, staticRenderFns } from "./TelegramBanner.vue?vue&type=template&id=b28369fe&scoped=true&"
import script from "./TelegramBanner.vue?vue&type=script&lang=js&"
export * from "./TelegramBanner.vue?vue&type=script&lang=js&"
import style0 from "./TelegramBanner.vue?vue&type=style&index=0&id=b28369fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28369fe",
  null
  
)

export default component.exports